<template>
  <div class="home-tab">
    <div class="user-info">
      <div
        class="header"
        @click="clickHeader('profileTab')">
        <span>
          Profile
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <div
        v-if="form.customer_profile.identity == 1"
        class="body info">
        <div class="half">
          <div class="item">
            <span>Title</span>
            <span>{{customerInfo.isrd_title_language}}</span>
          </div>
          <div class="item">
            <span>Last Name</span>
            <span>{{customerInfo.isrd_lst_nm}}</span>
          </div>
          <div class="item">
            <span>First Name</span>
            <span>{{customerInfo.isrd_fst_nm}}</span>
          </div>
          <div
            class="item"
            :class="{'border-bottom-none': !customerInfo.pp_no}">
            <span>Date of Birth</span>
            <span>{{customerInfo.isrd_dob_date}}</span>
          </div>
        </div>
        <div class="half">
          <div class="item">
            <span>HKID</span>
            <span>{{customerInfo.id_no}}</span>
          </div>
          <div
            v-if="customerInfo.pp_no"
            class="item">
            <span>Passport</span>
            <span>{{customerInfo.pp_no}}</span>
          </div>
          <div class="item">
            <span>Mobile No.</span>
            <span>{{customerInfo.phone}}</span>
          </div>
          <div class="item email">
            <span>Email</span>
            <span class="flex-column">
              <p v-if="customerInfo.email">
                {{customerInfo.email}}
                <email-tooltip :email="customerInfo.email"></email-tooltip>
                <font-awesome-icon
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </p>
              <p v-if="customerInfo.draft_email">
                {{customerInfo.draft_email}}
                <email-tooltip :email="customerInfo.draft_email"></email-tooltip>
                <font-awesome-icon
                  icon="warning"
                  class="warning icon"></font-awesome-icon>
              </p>
            </span>
          </div>
        </div>
      </div>
      <div
        v-else
        class="body info">
        <div class="half">
          <div class="item">
            <span>Company Name</span>
            <span>{{customerInfo.isrd_com_nm}}</span>
          </div>
          <div
            v-if="!customerInfo.attached_account"
            class="item">
            <span>Company Email</span>
            <span>
              {{customerInfo.email}}
              <email-tooltip :email="customerInfo.email"></email-tooltip>
            </span>
          </div>
          <div
            v-if="customerInfo.attached_account"
            class="item attach">
            <span>Company Email</span>
            <span class="column purple">
              <div class="flex flex-exist-link">
                <font-awesome-icon
                  icon="link"
                  class="icon"></font-awesome-icon>
                <div>{{ customerInfo.email }}</div>
                <email-tooltip :email="customerInfo.email"></email-tooltip>
              </div>
              <p
                class="flex flex-email"
                @click="handleShowEmail">
                <span>
                  {{ customerInfo.attached_accounts.length }}
                  linked account
                  <font-awesome-icon
                    icon="angle-right"
                    class="icon-right icon"></font-awesome-icon>
                </span>
              </p>
            </span>
          </div>
        </div>
        <div class="half">
          <div class="item">
            <span>Contact Name</span>
            <span>{{customerInfo.contact_nm}}</span>
          </div>
          <div class="item">
            <span>Contact Mobile No.</span>
            <span>{{customerInfo.contact_phone}}</span>
          </div>
          <div class="item">
            <span>Contact Email</span>
            <span>
              {{customerInfo.contact_email}}
              <email-tooltip :email="customerInfo.contact_email"></email-tooltip>
            </span>
          </div>
          <div class="item border-bottom-none">
            <span>Business Registration Number</span>
            <span>{{customerInfo.id_no}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div
        class="header"
        @click="clickHeader('ticketTab')">
        <span>
          Tickets
          <span class="num">{{ticketNum}}</span>
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <ticket-table
        :showHeader="false"
        :size="6"
        :customerId="customerId"
        @getTicketNum="getTicketNum"></ticket-table>
    </div>
    <div class="box">
      <div
        class="header"
        @click="clickHeader('policyTab')">
        <span>
          Policies
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <policy-table
        :showHeader="false"
        :size="6"
        :customerId="customerId"></policy-table>
    </div>
    <div class="box">
      <div
        class="header"
        @click="clickHeader('quoteTab')">
        <span>
          Quotes
          <font-awesome-icon
            icon="angle-right"
            class="icon"></font-awesome-icon>
        </span>
      </div>
      <quote-table
        :showHeader="false"
        :size="6"
        :customerId="customerId"></quote-table>
    </div>

    <link-account-email
      ref="link-email"
      :email="customerInfo.email"
      :companies="customerInfo.attached_accounts"
      :customerId="customerId"
    ></link-account-email>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import TicketTable from '@/views/components/ticket-table'
import PolicyTable from '@/views/components/policy-table'
import QuoteTable from '@/views/components/quote-table'
import {linkAccountEmail} from '../components/emailAccount'
export default {
  name: 'HomeTab',
  components:{
    TicketTable,
    PolicyTable,
    QuoteTable,
    linkAccountEmail
  },
  mixins: [MixinOptions],
  props: {
    // form: {
    //   type: Object,
    //   default: () => ({
    //     quote: [],
    //     policy: [],
    //     referral_rewards: []
    //   })
    // }
  },
  inject:['detailData'],
  data() {
    return {
      ticketNum: 0,
    }
  },
  computed: {
    form(){
      return this.detailData()
    },
    customerId(){
      return this.$route.query.customer_id || ''
    },

    customerInfo(){
      return this.form.customer_profile || {}
    }
  },
  methods: {
    clickHeader(tab) {
      this.$router.push({
        name: tab,
        query: {
          customer_id: this.customerId
        }
      })
    },
    getTicketNum(num){
      this.ticketNum = num
    },
    handleShowEmail(){
      this.$refs['link-email'].handleShow()
    },
  }
}
</script>

<style lang="scss" scoped>
.home-tab {
  .user-info{
    font-family: inter;
    margin-bottom: 20px;
    border-radius: 6px;
    border: 1px solid #E1E4E8;
    .header{
      background: #F6F8FA;
      border-bottom: 1px solid #E1E4E8;
      border-radius: 6px 6px 0px 0px;
      font-weight: 600;
      font-size: 14px;
      color: #0366D6;
      height: 52px;
      display: flex;
      align-items: center;
      padding: 16px;
      cursor: pointer;
      .icon{
        margin-left: 6px;
      }
    }
    .info{
      display: flex;
      .half{
        flex: 1;
        border-right: 1px solid #E1E4E8;
        .item{
          display: flex;
          border-bottom: 1px solid #D1D5DA;
          span{
            padding: 8px 16px;
            flex: 1;
            font-size: 14px;
            line-height: 20px;
            &:first-child{
              font-weight: 600;
              color: #586069;
            }
            &:last-child{
              font-weight: 400;
              color: #24292E;
            }
          }
          &.border-bottom-none{
            border-bottom: none;
          }
        }
        &:last-child{
          border-right: none;
        }
        .email{
          height: 61px;
          border-bottom: none;
          .flex-column{
            display: flex;
            flex-direction: column;
            p{
              padding: 0;
              .icon{
                margin-left: 9px;
                font-weight: 900;
                font-size: 14px;
              }
              .check{
                color: #22863A;
              }
              .warning{
                color: #B08800;
              }
              & + p{
                margin-top: 5px;
              }
            }
          }
        }
        .attach{
          min-height: 61px;
        }
        .purple{
          color: #6F42C1 !important;
          .icon{
            margin-right: 4px;
          }
          .flex-exist-link{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            display: flex;
            align-items: center;
            color: #6F42C1;
            span{
              margin-left: 6px;
            }
          }
          .flex-email{
            align-items: center;
            cursor: pointer;
            span{
              margin-right: 6px;
              font-size: 14px;
              font-weight: 400 !important;
              line-height: 20px;
              display: flex;
              align-items: center;
              color: #6F42C1 !important;
            }
            .icon-right{
              font-weight: 900;
              font-size: 16px;
              line-height: 20px;
              margin-left: 6px;
              color: #6F42C1;
            }
          }
        }
      }
    }
    .body{
      .tr{
        display: flex;
        padding: 10px 15px;
        background: #FFFFFF;
        .empty,.requester,.assignee,.status,.created{
          flex: 1;
        }
        .empty{
          display: flex;
          .icon{
            color: #606266;
            &.gray {
              color: #586069;
            }
            &.green {
              color: #22863A;
            }
            &.red {
              color: #D73A49;
            }
          }
          .type-status{
            color: #24292E;
            font-weight: 600;
            font-size: 12px;
            background: #FFFFFF;
            border: 1px solid #6A737D;
            border-radius: 100px;
            transform: rotate(0.03deg);
            padding: 1px 8px;
            margin-left: 15px;
            height: 20px;
          }
          .right{
            margin-left: 17px;
            .time{
              display: flex;
              flex-direction: column;
              font-weight: 400;
              font-size: 12px;
              color: #24292E;
              height: 36px;
              justify-content: center;
            }
            .icons{
              .table-icon{
              &.margin-top-flex{
                margin-top: 5px;
              }
              .icon{
                margin-right: 10px;
                img{
                  height: 22px;
                  width: 22px;
                }
              }
              .icon-content{
                height: 22px;
                width: 22px;
                border-radius: 5px;
                background-color: #E1E4E8;
                color: #6A737D;
                font-size: 14px;
                text-align: center;
                line-height: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #e1e4e8;
              }
              .backgroud-width{
                background: #fff!important;
                border: 1px solid #e1e4e8;
              }
            }
            }
          }
        }
        .subject{
          flex: 2;
          .circle{
            display: flex;
            align-items: center;
            height: 20px;
            margin-right: 5px;
            span{
              transform: rotate(0.03deg);
              width: 8px;
              height: 8px;
              border-radius: 8px;
              display: inline-block;
            }
            .blue{
              background: #0366D6;
            }
            .yellow{
              background: #DBAB09;
            }
          }
          .info{
            display: flex;
            flex-direction: column;
            .showLick{
              font-weight: 600;
              font-size: 14px;
              color: #24292E;
              transform: rotate(0.03deg);
              text-decoration: none;
            }
            .liter-text{
              font-weight: 400;
              font-size: 12px;
              color: #6A737D;
              transform: rotate(0.03deg);
            }
          }
        }
        .assignee{
          .text-span{
            font-weight: 400;
            font-size: 14px;
            color: #24292E;
            transform: rotate(0.03deg);
          }
        }
        .requester{
          font-weight: 400;
          font-size: 12px;
          color: #24292E;
        }
        .status{
          .status-height{
            height: 18px;
            line-height: 18px;
            padding: 0px 10px;
            border-radius: 100px;
            transform: rotate(0.03deg);
            font-weight: 600;
            font-size: 12px;
          }
          .status-one{
            border: 1px solid #735C0F;
            color: #735C0F;
            display: inline-block;
          }
          .status-two{
            border: 1px solid #0366D6;
            color: #0366D6;
            display: inline-block;
          }
          .status-three{
            border: 1px solid #22863A;
            color: #22863A;
            display: inline-block;
          }
          .span-status-stts{
            color: #FFFFFF;
            &.orange-light {
              background: #E36209;
            }
            &.yellow-dark {
              background: #DBAB09;
            }
            &.blue {
              background: #0366D6;
            }
            &.green {
              background: #28A745;
            }
            &.red {
              background: #D73A49;
            }
            &.purple {
              background: #6F42C1;
            }

          }
        }
        .created{
          display: flex;
          flex-direction: column;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          height: 36px;
          color: #24292E;
          transform: rotate(0.03deg);
        }
        & + .tr{
          border-top:  1px solid #D1D5DA;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
  }
  .box{
    font-family: inter;
    margin-bottom: 20px;
    border-radius: 6px;
    .header{
      background: #F6F8FA;
      border: 1px solid #E1E4E8;
      border-bottom: none;
      border-radius: 6px 6px 0px 0px;
      font-weight: 600;
      font-size: 14px;
      color: #0366D6;
      height: 52px;
      display: flex;
      align-items: center;
      padding: 16px;
      cursor: pointer;
      span{
        height: 20px;
      }
      .icon{
        margin-left: 6px;
      }
      .num{
        width: 18px;
        height: 16px;
        background: rgba(209, 213, 218, 0.5);
        border-radius: 100px;
        color: #24292E;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        padding: 0px 6px;
        margin-left: 4px;
      }
    }
    /deep/ .el-table{
      border: 1px solid #E1E4E8;
      border-radius: 0;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
}
</style>
